var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_722_51304)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "black",
    fillOpacity: 0.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4162 32C19.8927 32 19.412 31.8618 19.015 31.5894C18.6082 31.3091 18.0925 30.7525 17.9543 29.6919C17.7305 27.8042 17.6177 25.8931 17.6157 24.0014C17.6157 22.1098 17.7286 20.1987 17.9524 18.3188C18.0925 17.2464 18.6082 16.6918 19.015 16.4116C19.5969 16.0107 20.3675 15.8978 21.181 16.0943C24.2053 16.8222 30.3356 20.1559 32.7059 22.1137C33.2586 22.571 33.5798 23.2541 33.5836 23.9917V24.0112C33.5798 24.7468 33.2606 25.4318 32.7059 25.8892C30.3356 27.847 24.2033 31.1807 21.181 31.9085C20.9202 31.9689 20.6634 32 20.4162 32ZM20.4123 17.5559C20.206 17.5559 20.0289 17.6026 19.8966 17.6941C19.6319 17.877 19.5326 18.239 19.4976 18.5114C19.2835 20.3194 19.1726 22.1701 19.1726 23.9995C19.1726 25.8308 19.2816 27.6796 19.4976 29.4973C19.5326 29.76 19.63 30.1239 19.8966 30.3049C20.1106 30.4528 20.4376 30.482 20.8171 30.3906C23.5358 29.7367 29.5396 26.4808 31.7154 24.6845C31.908 24.5249 32.0248 24.27 32.0267 24.0014V23.9937C32.0248 23.729 31.908 23.4721 31.7154 23.3125C29.5396 21.5143 23.5358 18.2604 20.8171 17.6065C20.6731 17.5734 20.5388 17.5559 20.4123 17.5559Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_722_51304",
    x: -100,
    y: -100,
    width: 248,
    height: 248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_722_51304"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_722_51304",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6fadb33a402e26080823dd41f8dd9121.svg";
export { ForwardRef as ReactComponent };